import React, {useState} from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import NewReferral from "components/HealthRecords/Referrals/NewReferral";
import PatientSearchField from "components/Patient/PatientSearchField";

const NewReferralAdmin = ({patient, document, physician, onClose, request}) => {

  const [selectedPatient, setSelectedPatient] = useState(patient);

  const physicianId = physician?.id || document?.physician_id || request?.physician_id || selectedPatient?.primary_physician;
  const id = document?.id || request?.id;

  return (
    <div className="new-referral-admin">
      {!selectedPatient &&
        <div className="patient-search">
          <PatientSearchField
            onSelect={setSelectedPatient}
          />
        </div>}
      {selectedPatient && <NewReferral
        patient={selectedPatient}
        form={selectedPatient.id + id}
        copyFrom={document?.referral || request}
        physicianId={physicianId}
        onClose={onClose}
      />}
    </div>
  );
}
NewReferralAdmin.propTypes = {
  patient: PropTypes.object,
  physician: PropTypes.object,
  onClose: PropTypes.func,
  document: PropTypes.object,
  request: PropTypes.object
};

export default NewReferralAdmin;
